import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-confirm-message',
    templateUrl: './confirm-message.component.html',
    styleUrls: ['./confirm-message.component.scss'],
    standalone: false
})
export class ConfirmMessageComponent implements OnInit, OnChanges, OnDestroy {
  @Input() showForm: boolean;
  @Input() message: string;
  @Input() color: string; // Success, Primary or Danger...
  @Input() title = '';
  @Input() detail = '';
  @Input() confirmLabel = '';
  @Input() cancelLabel = '';
  @Input() busy = false;
  @Input() presentation: 'dialog' | 'inline' = 'dialog';
  @Output() onConfirm = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  private dialog?: NgbModalRef;
  private destroyed = false;
  constructor(public globalService: GlobalService, private modals: NgbModal) {}

  ngOnInit(): void {}

  get heading() { return this.title || ((this.message || '').length <= 100 ? this.message : '') || (this.globalService.isRTL ? 'يرجى تأكيد الإجراء' : 'Confirm action'); }
  get body() { return this.title || (this.message || '').length > 100 ? (this.message || '').replace(/\\n/g, '\n') : ''; }
  get acceptLabel() {
    if (this.confirmLabel) return this.confirmLabel;
    const verb = /^(delete|restore|remove|discard)\b/i.exec(this.message || '')?.[1]?.toLowerCase();
    const english = {delete:'Delete',restore:'Restore',remove:'Remove',discard:'Discard'};
    const arabic = {delete:'حذف',restore:'استعادة',remove:'إزالة',discard:'تجاهل'};
    return verb ? (this.globalService.isRTL ? arabic : english)[verb] : (this.globalService.isRTL ? 'تأكيد' : 'Confirm');
  }
  get rejectLabel() { return this.cancelLabel || (this.globalService.isRTL ? 'إلغاء' : 'Cancel'); }

  ngOnChanges(): void {
    if (!this.showForm || this.presentation === 'inline') { this.dismissDialog(); return; }
    if (!this.dialog) {
      const ref = this.modals.open(MessageDialogComponent, {centered:true,scrollable:true,backdrop:'static',keyboard:true,beforeDismiss:()=>this.destroyed || !this.showForm || this.presentation==='inline' || !this.busy,windowClass:'user-message-modal',ariaLabelledBy:'user-message-dialog-title',ariaDescribedBy:'user-message-dialog-description'});
      this.dialog = ref;
      ref.result.then(result => {
        if (this.dialog !== ref || this.destroyed || !this.showForm) return;
        this.dialog = undefined;
        if (result === 'confirm') this.Confirm(); else this.Cancel();
      }, () => {
        if (this.dialog !== ref || this.destroyed || !this.showForm) return;
        this.dialog = undefined; this.Cancel();
      });
    }
    Object.assign(this.dialog.componentInstance, {title:this.heading,message:this.body,detail:this.detail,confirmLabel:this.acceptLabel,cancelLabel:this.rejectLabel,severity:'confirmation',destructive:this.color==='danger',isRTL:this.globalService.isRTL,busy:this.busy});
  }

  private dismissDialog() { const ref=this.dialog; this.dialog=undefined; ref?.dismiss('owner-closed'); }
  ngOnDestroy() { this.destroyed=true; this.dismissDialog(); }

  Confirm() {
    if (this.busy) return;
    this.showForm = false;
    this.dismissDialog();
    this.onConfirm.emit();
  }

  Cancel() {
    if (this.busy) return;
    this.showForm = false;
    this.dismissDialog();
    this.onCancel.emit();
  }
}
